var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile2User(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.63355 9.05465C7.55023 9.04631 7.45025 9.04631 7.35859 9.05465C5.37555 8.98799 3.80078 7.36323 3.80078 5.36352C3.80078 3.32215 5.45054 1.66406 7.50024 1.66406C9.54161 1.66406 11.1997 3.32215 11.1997 5.36352C11.1914 7.36323 9.6166 8.98799 7.63355 9.05465Z",
    stroke: "#344054",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6747 3.32812C15.2912 3.32812 16.591 4.63627 16.591 6.24436C16.591 7.81913 15.3411 9.10228 13.783 9.1606C13.7164 9.15227 13.6414 9.15227 13.5664 9.1606",
    stroke: "#344054",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.4654 12.128C1.44903 13.4778 1.44903 15.6774 3.4654 17.0189C5.75673 18.552 9.51452 18.552 11.8058 17.0189C13.8222 15.6691 13.8222 13.4694 11.8058 12.128C9.52285 10.6032 5.76507 10.6032 3.4654 12.128Z",
    stroke: "#344054",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2812 16.6633C15.8812 16.5383 16.4477 16.2967 16.9143 15.9384C18.2142 14.9636 18.2142 13.3555 16.9143 12.3806C16.4561 12.0307 15.8978 11.7974 15.3062 11.6641",
    stroke: "#344054",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile2User);
export default __webpack_public_path__ + "static/media/profile-2user.1445dad38e9f5fc12856598d274f0d80.svg";
export { ForwardRef as ReactComponent };